import { render, staticRenderFns } from "./orderMonitor.vue?vue&type=template&id=11a8cf7c&scoped=true"
import script from "./orderMonitor.vue?vue&type=script&lang=js"
export * from "./orderMonitor.vue?vue&type=script&lang=js"
import style0 from "./orderMonitor.vue?vue&type=style&index=0&id=11a8cf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8cf7c",
  null
  
)

export default component.exports